import actionTypes from "../actionTypes";

const defaultState = {
    collectionId: 0,
    showTypeDetail: false,
    typeCurPage: 1,
    courseType:'',
    classObj:{},
}

const pageCacheReducer = (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.SetResourcePage:
            return Object.assign({}, state, action);
        case actionTypes.SetInsClass:
            return Object.assign({},state,action);
        default:
            return state;
    }

}

export default pageCacheReducer